export default __webpack_public_path__ + "static/media/Web-Concept-1.02dfe39d.png";